import { Component, OnInit } from '@angular/core'
import { UntypedFormBuilder } from '@angular/forms'
import { ReportsService, ReportParamService } from '../../../../../api/services'
import { MessageService, ConfirmationService, LazyLoadEvent } from 'primeng/api'
import { Router, ActivatedRoute } from '@angular/router'
import { DataPageOfReportParam, ReportParam } from '../../../../../api/models'

@Component({
  selector: 'app-reportparam-list',
  templateUrl: './reportparam-list.component.html',
  styleUrls: ['./reportparam-list.component.css'],
})
export class ReportparamListComponent implements OnInit {
  cols: { field: string; header: string }[]
  reportParam: DataPageOfReportParam
  selectedReportParam: ReportParam
  rows: number
  reportForm
  reportId: number
  reportName: string = ''

  showRecords: boolean = false
  currentPage: number = 1
  first: number = 0 // Variable to track the first record

  constructor(
    private fb: UntypedFormBuilder,
    private reportparamservice: ReportParamService,
    private messageService: MessageService,
    private confirmation: ConfirmationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      let data = params
      this.reportId = data.report_Id
      this.reportName = data.report_Name
    })
    this.cols = [
      { field: 'reportparamname', header: 'Param Name' },
      { field: 'reportparamshortnote', header: 'Display Name' },
      { field: 'datatype', header: 'Data Type' },
    ]

    this.loadReportParamsList(this.reportId, 1, '', '')
  }

  loadReportParamsList(
    reportId: number,
    pageNumber: number,
    sortcolumn: string,
    sortorder: string,
  ): void {
    this.reportparamservice
      .reportParamGet({
        pageNumber: pageNumber,
        pageSize: 10,
        reportId: reportId,
      })
      .subscribe((result) => {
        this.reportParam = result
        debugger
        this.rows = this.reportParam.pageSize
        if (result.totalRecords > 0) {
          this.showRecords = true
        } else {
          this.showRecords = false
        }
        // console.log(result);
      })
  }

  onAddParamReports(): void {
    debugger

    this.router.navigate(['administration/add-paramreports'], {
      queryParams: { report_Id: this.reportId, report_Name: this.reportName },
      skipLocationChange: true,
    })
  }

  onEditParamReport(reportParamId): void {
    this.router.navigate(['administration/edit-paramreports'], {
      queryParams: {
        report_Id: this.reportId,
        report_Name: this.reportName,
        reportparam_Id: reportParamId,
      },
      skipLocationChange: true,
    })
  }

  onDeleteParamReport(event, reportparamid: number) {
    this.confirmation.confirm({
      key: 'delete_confirmation',
      message: 'Are you sure you want to delete this Param?',
      accept: () => {
        this.onDeleteParam(reportparamid)
      },
    })
  }

  onDeleteParam(reportparamid: number) {
    this.reportparamservice
      .reportParamDelete({
        id: reportparamid,
      })
      .subscribe((data) => {
        this.messageService.add({
          key: 'alertToast',
          severity: 'success',
          summary: 'Confirmation!',
          detail: 'Param Deleted Successfully',
          life: 5000,
        })

        this.loadReportParamsList(this.reportId, 1, '', '')
      })
  }

  moveUp(value, index) {
    debugger
    if (index > 0) {
      const tmp = this.reportParam.data[index - 1]
      this.reportParam.data[index - 1] = this.reportParam.data[index]
      this.reportParam.data[index] = tmp
      this.UpdateRowOrder(value.reportparamid, index - 1, 'UP', tmp)
    }
  }

  moveDown(value, index) {
    if (index < this.reportParam.data.length - 1) {
      const tmp = this.reportParam.data[index + 1]
      this.reportParam.data[index + 1] = this.reportParam.data[index]
      this.reportParam.data[index] = tmp

      this.UpdateRowOrder(value.reportparamid, index + 1, 'dn', tmp)
    }
  }

  UpdateRowOrder(value: number, newseqno: number, action: string, tmp) {
    this.reportparamservice
      .reportParamUpdateRowSequence({
        Id: value,
        Seqno: newseqno,
        action: action,
        itemtypeid: tmp.reportparamid,
      })
      .subscribe((data) => {
        console.log('Done')
      })
  }

  nextPage($event: LazyLoadEvent) {
    debugger
    console.log($event)
    let nextPage = $event.first / $event.rows + 1
    var order = 'Asc'
    if ($event.sortOrder == -1) {
      order = 'Desc'
    }
    if ($event.first == 0) {
      this.loadReportParamsList(this.reportId, 1, $event.sortField, order)
      //this.currentPage = 1;
    } else {
      this.loadReportParamsList(
        this.reportId,
        nextPage,
        $event.sortField,
        order,
      )
    }
    //this.currentPage = nextPage;

    this.currentPage = Math.floor($event.first / $event.rows) + 1
  }
}
